import React from 'react';

const Mobile = () => {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 49 88">
			<g clip-path="url(#a)">
				<path
					fill="#fff"
					d="M5.444 0C2.46 0 0 2.706 0 5.992V81.89c0 3.285 2.46 5.992 5.444 5.992h38.112c2.985 0 5.444-2.707 5.444-5.992V5.992C49 2.706 46.54 0 43.556 0H5.444Zm0 3.995h38.112c1.037 0 1.814.855 1.814 1.997v3.995H3.63V5.992c0-1.142.777-1.997 1.814-1.997ZM3.63 13.98h41.74v55.925H3.63V13.981Zm0 59.92h41.74v7.989c0 1.142-.777 1.997-1.814 1.997H5.444c-1.037 0-1.814-.855-1.814-1.997V73.9Z"
				/>
				<path
					fill="#12D231"
					d="m38.111 31.238-12.704-7.99a1.696 1.696 0 0 0-.965-.279 1.735 1.735 0 0 0-.85.28L10.89 31.238c-.56.356-.908 1.012-.908 1.718v15.978c0 .706.348 1.362.908 1.718l12.704 7.99c.29.189.623.285.964.279.303-.017.593-.114.85-.28l12.704-7.99c.56-.355.908-1.011.908-1.717V32.956c0-.706-.348-1.362-.908-1.718Zm-15.426 22.25-9.074-5.712V36.384l9.074 5.713v11.391ZM24.5 38.635l-9.047-5.68 9.047-5.678 9.047 5.679-9.047 5.679Zm10.889 9.144-9.074 5.712V42.1l9.074-5.712v11.391ZM24.5 81.89c1.503 0 2.722-1.341 2.722-2.996s-1.219-2.996-2.722-2.996-2.722 1.341-2.722 2.996c0 1.654 1.219 2.996 2.722 2.996Z"
				/>
			</g>
			<defs>
				<clipPath id="a">
					<path fill="#fff" d="M0 0h49v87.882H0z" />
				</clipPath>
			</defs>
		</svg>
	);
};

export default Mobile;
